import { createSlice } from "@reduxjs/toolkit";

import { createInquiry as createInquiryAPI, createUser as createUserAPI } from "../../sdk/apis";
import Inquiry from "../../sdk/containers/Inquiry";
import User from "../../sdk/containers/User";

interface InquiryState {
  inquiry: Inquiry,
  extendExpiration: boolean,
  validateSuccess: boolean,
  submitSuccess: boolean,
  tosFlag: boolean,
  hopiFlag: boolean,
  errorMsg: {
    account_id?: string[];
    account_idEn?: string[];
    username?: string[];
    usernameEn?: string[];
    email?: string[];
    emailEn?: string[];
    subject?: string[];
    subjectEn?: string[];
    body?: string[];
    bodyEn?: string[];
  }
}
export const inquirySlice = createSlice({
  name: 'inquiry',
  initialState: {
    inquiry: new Inquiry(),
    extendExpiration: false,
    validateSuccess: false,
    submitSuccess: false,
    errorMsg: {},
    tosFlag: false,
    hopiFlag: false,
  } as InquiryState,
  reducers: {
    setInquiry: (state, action) => {
      state.inquiry = action.payload;
    },
    setExtendExpiration: (state, action) => {
      state.extendExpiration = action.payload;
    },
    setValidateSuccess: (state, action) => {
      state.validateSuccess = action.payload;
    },
    setSubmitSuccess: (state, action) => {
      state.submitSuccess = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.errorMsg = action.payload;
      if (action.payload.account_id == "この項目は必須です。") {
        state.errorMsg['account_idEn'] = ['This field is required.'];
      }
      if (action.payload.username == "この項目は必須です。") {
        state.errorMsg['usernameEn'] = ['This field is required.'];
      }
      if (action.payload.email == "この項目は必須です。") {
        state.errorMsg['emailEn'] = ['This field is required.'];
      } else if (action.payload.email == "有効なメールアドレスを入力してください。") {
        state.errorMsg['emailEn'] = ['A valid email address is required.'];
      }
      if (action.payload.subject == "この項目は必須です。") {
        state.errorMsg['subjectEn'] = ['This field is required.'];
      }
      if (action.payload.body == "この項目は必須です。") {
        state.errorMsg['bodyEn'] = ['This field is required.'];
      }
    },
    setTosFlag: (state, action) => {
      state.tosFlag = action.payload;
    },
    setHopiFlag: (state, action) => {
      state.hopiFlag = action.payload;
    },
  },
});

export const { setInquiry, setExtendExpiration, setValidateSuccess, setSubmitSuccess, setErrorMsg, setTosFlag, setHopiFlag } = inquirySlice.actions;

interface newAccountInitialState {
  accountInfo: User;
  checkedDisclaimer: boolean;
  validateSuccess: boolean;
  createSuccess: boolean;
  errorMsg: {
    address?: string[];
    department?: string[];
    department_f?: string[];
    department_fEn?: string[];
    email?: string[];
    emailEn?: string[];
    job_title?: string[];
    job_title_f?: string[];
    job_title_fEn?: string[];
    name?: string[];
    name_f?: string[];
    name_fEn?: string[];
    organization?: string[];
    organization_f?: string[];
    organization_fEn?: string[];
    purpose?: string[];
    tel?: string[];
    usage_classification?: string[];
  }
}

export const newAccountSlice = createSlice({
  name: 'newAccount',
  initialState: {
    accountInfo: new User(),
    checkedDisclaimer: false,
    validateSuccess: false,
    createSuccess: false,
    errorMsg: {},
  } as newAccountInitialState,
  reducers: {
    setAccountInfo: (state, action) => {
      state.accountInfo = action.payload;
    },
    setValidateAccountSuccess: (state, action) => {
      state.validateSuccess = action.payload;
    },
    setCreateAccountSuccess: (state, action) => {
      state.createSuccess = action.payload;
    },
    setCreateAccountErrorMsg: (state, action) => {
      state.errorMsg = action.payload;
      if (action.payload.name_f == "この項目は空にできません。") {
        state.errorMsg['name_fEn'] = ['This field is required.'];
      } else if (action.payload.name_f == "半角アルファベットのみで入力してください。") {
        state.errorMsg['name_fEn'] = ['Please enter only half-width alphabet characters.'];
      }

      if (action.payload.email == "この項目は空にできません。") {
        state.errorMsg['emailEn'] = ['This field is required.'];
      } else if (action.payload.email == "有効なメールアドレスを入力してください。") {
        state.errorMsg['emailEn'] = ['Please enter a valid email address.'];
      }

      if (action.payload.department_f == "この項目は空にできません。") {
        state.errorMsg['department_fEn'] = ['This field is required.'];
      } else if (action.payload.department_f == "全角カタカナまたは「N/A」と入力してください。") {
        state.errorMsg['department_fEn'] = ['Please enter full-width katakana or "N/A".'];
      }
      if (action.payload.job_title_f == "この項目は空にできません。") {
        state.errorMsg['job_title_fEn'] = ['This field is required.'];
      } else if (action.payload.job_title_f == "全角カタカナまたは「N/A」と入力してください。") {
        state.errorMsg['job_title_fEn'] = ['Please enter full-width katakana or "N/A".'];
      }
      if (action.payload.organization_f == "この項目は空にできません。") {
        state.errorMsg['organization_fEn'] = ['This field is required.'];
      } else if (action.payload.organization_f == "全角カタカナまたは「N/A」と入力してください。") {
        state.errorMsg['organization_fEn'] = ['Please enter full-width katakana or "N/A".'];
      }
    },
  },
});

export const { setAccountInfo, setValidateAccountSuccess, setCreateAccountSuccess, setCreateAccountErrorMsg } = newAccountSlice.actions;

export function validateInquiry(inquiryInfo: Inquiry, extendExpiration: boolean) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    createInquiryAPI(inquiryInfo, true, extendExpiration).then((result) => {
      // TODO status要確認!!!
      const status = result[0]
      const data = result[1]
      if (data === true) {
        dispatch(setValidateSuccess(true));
      } else {
        dispatch(setErrorMsg(result[1]));
      }
    });
  }
}

export function submit(inquiryInfo: Inquiry) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    createInquiryAPI(inquiryInfo, false, false).then((result) => {
      const status = result[0]
      const data = result[1]
      if (status === 201) {
        dispatch(setSubmitSuccess(true));
      } else {
        dispatch(setErrorMsg(data));
      }
    });
  }
}

export function validateAccount(userInfo: User) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();
    createUserAPI(userInfo, true).then((result: (boolean | User)[]) => {
      const status = result[0]
      const data = result[1]
      if (data === true) {
        dispatch(setValidateAccountSuccess(true));
      } else {
        dispatch(setCreateAccountErrorMsg(data));
      }
    });
  }
}

export function createAccount(userInfo: User) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();
    createUserAPI(userInfo, false).then((result: (boolean | Object)[]) => {
      const status = result[0];
      const data = result[1];
      if (status === 200 && data === true) {
        dispatch(setCreateAccountSuccess(true));
      } else {
        dispatch(setCreateAccountErrorMsg(data));
      }
    });
  }
}

const newAccountSliceReducer = newAccountSlice.reducer;
export { newAccountSliceReducer };
const inquirySliceReducer = inquirySlice.reducer;
export { inquirySliceReducer };
